<template>
    <Layout>
      <PageHeader :title="title" :items="items" />
  
    <div class="row" v-if="userData.permissions['view_payment_options']==1">
        <div class="col-12">
          <div class="card">
            <div class="card-body">
              <div class="mb-2 float-end">
                <b-button v-show="userData.permissions['new_payment_option']==1" v-b-modal.new-option size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Option</b-button>
              </div>
              <div class="clearfix"></div>
              <div class="row">
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_length" class="dataTables_length">
                    <label class="d-inline-flex align-items-center">
                      Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                    </label>
                  </div>
                </div>
                <div class="col-sm-12 col-md-6">
                  <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                    <label class="d-inline-flex align-items-center">
                      Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                    </label>
                  </div>
                </div>
              </div>
              <div class="table-responsive">
                <b-table
                  :items="Items"
                  :fields="Fields"
                  responsive="sm"
                  :per-page="perPage"
                  :current-page="currentPage"
                  :filter="filter"
                  :filter-included-fields="filterOn"
                  @filtered="Filtered"
                  :busy="IsBusy"
                >
                <template #table-busy><div class="text-center text-primary my-2"><b-spinner class="align-middle" type="grow" small></b-spinner> <strong>No Data Found</strong></div></template>
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(role)="data">
                  {{ data.item.role.name }}
                </template>
                  <template #cell(set_default)="data">
                  <span v-if="data.item.set_default==1">
                    <b-button type="button" class="btn-sm btn" variant="info" v-b-modal.password> <i class="mdi mdi-check"></i> Default </b-button>
                  </span>
                  <span v-else>
                    <b-button v-show="userData.permissions['edit_payment_option']==1" @click="makedefault(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="secondary" v-b-modal.password> <i class="mdi mdi-lock"></i> Set as Default</b-button>
                    </span>
                  </template>
                <template #cell(actions)="data">
                  <div class="btn-group">
                  <b-button :disabled="data.item.name == 'Online Payment'" v-show="userData.permissions['edit_payment_option']==1" @click="edit(data.item.id,data.item.name,data.item.account_number )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                  <b-button :disabled="data.item.name == 'Online Payment'" v-show="userData.permissions['delete_payment_option']==1" @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                  </div>
                </template>
                </b-table>
              </div>
              <div class="row">
                <div class="col">
                  <div class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0">
                      <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to view Payment Options</span></center>
          </div>
        </div>
      </div>
    </div>
      <b-modal id="new-option" centered title="New Payment Option" title-class="font-18" hide-footer>
          <form @submit.prevent="addOption">
              <div class="form-group mb-2">
              <label>Option Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Account Number</label>
              <input v-model="account_number" type="number" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="edit-option" centered title="Edit Payment Option" title-class="font-14" hide-footer>
          <form @submit.prevent="editOption">
              <div class="form-group mb-2">
              <input v-model="id" type="hidden">
              <label>Option Name</label>
              <input v-model="name" type="text" class="form-control" />
              </div>
              <div class="form-group mb-2">
              <label>Account Number</label>
              <input v-model="account_number" type="number" class="form-control" />
              </div>
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="change-option" centered title="Set as Default Option" title-class="font-18" hide-footer>
          <form @submit.prevent="makeDefualtOption">
            <input v-model="id" type="hidden">
            Are you sure you want to make <b>{{ name }}</b> the default Payment Option
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('change-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
      <b-modal id="delete-option" centered title="Delete Payment Option" title-class="font-12" hide-footer>
          <form @submit.prevent="removeOption">
              <input v-model="id" type="hidden">
                Are you sure you want to delete the Payment Option : <b>{{ name }}</b> ?
              <div class="form-group d-flex justify-content-end">
                  <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-option')" >Cancel</b-button>
                  <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
              </div>
          </form>
      </b-modal>
  
    </Layout>
  </template>
  
  <script>
  import axios from "axios";
  // import Multiselect from "vue-multiselect";
  import Layout from "../../layouts/main";
  import PageHeader from "@/components/page-header";
  import appConfig from "@/app.config";
  import { paymentoptionMethods, paymentoptionComputed } from "@/state/helpers";
  
  export default {
    page: {
      title: "Payment Options",
      meta: [{ name: "description", content: appConfig.description,},],
    },
    components: {
      Layout,PageHeader
    },
    data() {
      return {
        userData: JSON.parse(localStorage.getItem("user")),
        title: "Payment Options",
        items: [ {text: "Dashboard",to: "/",}, {text: "Payment Options",active: true, }, ],
        TotalRows: 1,
        currentPage: 1,
        perPage: 10,
        Options: [10, 50, 100, 150, 200],
        filter: null,
        todoFilter: null,
        filterOn: [],
        sortDesc: true,
        isBusy: true,
        fields: [
            { key: 'index', label: '#', visible: true },
            { key: 'id', label: 'ID', visible: false },
            { key: 'name', label: 'Name', visible: true },
            { key: 'account_number', label: 'Account Number', visible: true },
            { key: 'set_default', label: 'Default', visible: true },
            { key: 'addedby', label: 'Added by', visible: true },
            { key: 'actions', label: 'Actions', visible: true },
          ],
        id:'',
        name:'',
        account_number:'',
      };
    },
    computed: {
      ...paymentoptionComputed,
      List() { return this.paymentoptions.length; },
      Fields() { return this.fields.filter(field => field.visible) },
      Items() { return this.paymentoptions.map((d) => ({...d }))},
      IsBusy() { let a=false; if (this.paymentoptions.length>0) { a=false;} else { a=true;} return a },
    },
    mounted() {
      this.fetchPaymentoptions();
      this.TotalRows = this.paymentoptions.length;
      this.isBusy=false;
    },
    methods: {
      ...paymentoptionMethods,
      Filtered(filteredItems) {
        this.TotalRows = filteredItems.length;
        this.currentPage = 1;
      },
      edit(id,name,account_number){
        this.id=id;
        this.name=name;
        this.account_number=account_number;
        this.$bvModal.show('edit-option')
      },
      makedefault(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('change-option')
      },
      remove(id,name){
        this.id=id;
        this.name=name;
        this.$bvModal.show('delete-option')
      },
      async addOption() { 
        let formData = new FormData();
        formData.append("name", this.name);
        formData.append("account_number", this.account_number);
        let url = "/addmethod";
        await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
            this.fetchPaymentoptions();
            this.$bvModal.hide('new-option');
            this.name="";
            this.account_number="";
        }
        });
      },
      async makeDefualtOption(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/setdefault";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPaymentoptions();
          this.$bvModal.hide('change-option');
        }
      });
      },
      async editOption(){ 
      let formData = new FormData();
      formData.append("id", this.id);
      formData.append("name", this.name);
      formData.append("account_number", this.account_number);
      let url = "/updatemethod";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPaymentoptions();
          this.$bvModal.hide('edit-option');
          this.name="";
          this.account_number="";
        }
      });
      },
      async removeOption() { 
      let formData = new FormData();
      formData.append("id", this.id);
      let url = "/removemethod";
      await axios.post(url, formData).then((response) => {
        if (response.status == 200) {
          this.fetchPaymentoptions();
          this.$bvModal.hide('delete-option');
        }
      });
      },
    },
  };
  </script>